import { IInfoTeamPlayers } from "@grassrootly/api";
import { PayloadAction, createPersistReducer, initReducer, PersistConfig } from "@grassrootly/rn-core";
import AsyncStorage from "@react-native-async-storage/async-storage";

export interface InfoPlayers {
  info_players: { [key: string]: IInfoTeamPlayers };
}

const initialState: InfoPlayers = {
  info_players: {},
};

const infoPlayersSlice = initReducer({
  name: "info-players",
  initialState,
  reducers: {
    setInfoPlayers: (state: InfoPlayers, action: PayloadAction<IInfoTeamPlayers[]>) => {
      action.payload.forEach((player) => {
        state.info_players[player.groupId] = player;
      });
    },
    cleanState: () => {
      return initialState;
    },
  },
});

const persistConfig: PersistConfig<InfoPlayers> = {
  key: "info-players",
  storage: AsyncStorage,
};

export const infoPlayersActions = infoPlayersSlice.actions;

export default createPersistReducer(persistConfig, infoPlayersSlice.reducer);
